{
  "name": "@uppy/dashboard",
  "description": "Universal UI plugin for Uppy.",
  "version": "5.0.3",
  "license": "MIT",
  "style": "dist/style.min.css",
  "type": "module",
  "sideEffects": [
    "*.css"
  ],
  "scripts": {
    "build": "tsc --build tsconfig.build.json",
    "build:css": "sass --load-path=../../ src/style.scss dist/style.css && postcss dist/style.css -u cssnano -o dist/style.min.css",
    "typecheck": "tsc --build",
    "test": "vitest run --silent='passed-only'",
    "test:e2e": "vitest run --project browser"
  },
  "keywords": [
    "file uploader",
    "uppy",
    "uppy-plugin",
    "dashboard",
    "ui"
  ],
  "homepage": "https://uppy.io",
  "bugs": {
    "url": "https://github.com/transloadit/uppy/issues"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/transloadit/uppy.git"
  },
  "files": [
    "src",
    "lib",
    "dist",
    "CHANGELOG.md"
  ],
  "exports": {
    ".": "./lib/index.js",
    "./css/style.css": "./dist/style.css",
    "./css/style.min.css": "./dist/style.min.css",
    "./css/style.scss": "./src/style.scss",
    "./package.json": "./package.json"
  },
  "dependencies": {
    "@transloadit/prettier-bytes": "^0.3.4",
    "@uppy/provider-views": "workspace:^",
    "@uppy/thumbnail-generator": "workspace:^",
    "@uppy/utils": "workspace:^",
    "classnames": "^2.2.6",
    "lodash": "^4.17.21",
    "nanoid": "^5.0.9",
    "preact": "^10.5.13",
    "shallow-equal": "^3.0.0"
  },
  "devDependencies": {
    "@uppy/core": "workspace:^",
    "@uppy/google-drive": "workspace:^",
    "@uppy/url": "workspace:^",
    "@uppy/webcam": "workspace:^",
    "@vitest/browser": "^3.2.4",
    "cssnano": "^7.0.7",
    "jsdom": "^26.1.0",
    "playwright": "1.54.1",
    "postcss": "^8.5.6",
    "postcss-cli": "^11.0.1",
    "resize-observer-polyfill": "^1.5.0",
    "sass": "^1.89.2",
    "typescript": "^5.8.3",
    "vitest": "^3.2.4"
  },
  "peerDependencies": {
    "@uppy/core": "workspace:^"
  }
}
